export default "__VITE_ASSET__B6Ux$eK6__"